const sortBlock = (a, b, field="name") => {
  if (a[field] < b[field]) {
    return -1;
  }
  if (a[field] > b[field]) {
    return 1;
  }
  return 0;
};

export default sortBlock;
